export default [
    {
        path: 'impressao-exame',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-impressao-exame' */
            '@/views/exame-laboratorial/impressao-exame/Index'
        ),
        redirect: 'impressao-exame/create',
        children: [
            {
                name: 'exame-laboratorial-impressao-exame-create',
                path: 'create',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-impressao-exame' */
                    '@/views/exame-laboratorial/impressao-exame/Form.vue'
                ),
            },
        ],
    }
]